import { Modal, Tabs } from "antd";
import { FormattedMessage } from "react-intl";
import EventChart from "../charts/eventChart";
import { nFormatter } from "../services/public_functions";
import PriceChart from "../charts/priceChart";

const { TabPane } = Tabs;

const ChartsModal = (props) => {
  const {
    theme,
    domain,
    isChartsModalVisible,
    timezone,
    selectedEvent,
    toggleChartsModal,
    chartModalActiveTab,
    setChartModalActiveTab,
  } = props;
  return (
    <Modal
      centered
      // title="Charts"
      open={isChartsModalVisible}
      onOk={toggleChartsModal}
      onCancel={toggleChartsModal}
      header={false}
      footer={false}
      // transitionName=""
      className="chartsModal"
      // wrapClassName={customAntModalWrap}
      // style={{transformOrigin: `1030px ${modalPosition}px`, marginTop: `${modalPosition}px` }}
      // style={{ top: `${modalPosition}px` }}
    >
      <Tabs
        defaultActiveKey="1"
        activeKey={chartModalActiveTab}
        onChange={(key) => setChartModalActiveTab(key)}
      >
        <TabPane
          disabled={!selectedEvent.isPlottable}
          tab={
            <span>
              <i className="action_icon fas fa-chart-bar mx-1" />
              <FormattedMessage id="modal.event_chart" />
            </span>
          }
          key="1"
        >
          <EventChart selectedEvent={selectedEvent} nFormatter={nFormatter} />
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="action_icon fas fa-chart-area mx-1" />
              <FormattedMessage id="modal.price_chart" />
            </span>
          }
          key="2"
        >
          <PriceChart
            selectedEvent={selectedEvent}
            timezone={timezone}
            theme={theme}
            domain={domain}
          />
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="action_icon fas fa-chart-line mx-1" />
              Volatility
            </span>
          }
          key="3"
        >
          Coming Soon...
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="action_icon fas fa-exchange-alt rotate_90 mx-1" />
              Impact
            </span>
          }
          key="4"
        >
          Coming Soon...
        </TabPane>
      </Tabs>
    </Modal>
  );
};

export default ChartsModal;
